import { AuthGuard } from './auth.guard';
export const AUTH_GUARDS = [AuthGuard];
export { AuthGuard };



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/guards/index.ts